import {
  createSelector,
  createFeatureSelector,
} from '@ngrx/store';

import * as dashboardWidgetConfig from '@dashboard-widget/reducers/dashboard-widget-config.reducers';

export const selectDashboardWidgetConfigState = createFeatureSelector<dashboardWidgetConfig.State>(dashboardWidgetConfig.dashboardWidgetConfigurationFeature);

const { selectEntities } = dashboardWidgetConfig.adapter.getSelectors(selectDashboardWidgetConfigState);

export const selectEntityByWidgetId = (widgetId: number) => createSelector(selectEntities, (entities) => entities[widgetId]);

export const getDashboardWidgetConfig = (widgetId: number) => createSelector(selectEntityByWidgetId(widgetId), (item) => item != undefined ? item.config : null);
